export enum StorageKey {
  // InitRoute: 'startRoute',
  FromLogin = 'return_to',
  Version = 'x-client-version',
  FromOverview = 'from_overview',
  AwsError = 'aws_error',
  AnonUserId = 'prom_anonymousUserId'
}
